import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { RouteConstants } from '@app/constants/route.constants';
import { AuthenticationService } from '../authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
  constructor(private authenticationService: AuthenticationService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    //Roles are passed in route data
    const rolesNames = route.data.roles as string[];
    const userLogged = this.authenticationService.isUserLogged();
    const userRole = this.authenticationService.getUserRole();
    //Se abren todas las rutas al público
    // if (userLogged && rolesNames?.length && rolesNames.indexOf(userRole) === -1) {
    //   this.router.navigate([RouteConstants.EMPTY]);
    // } else if (!userLogged) {
    //   this.router.navigate([RouteConstants.LOGIN]);
    // }
    //Sólo se evalua si la ruta es específica para un rol
    if (rolesNames?.length && rolesNames.indexOf(userRole) === -1) {
      this.router.navigate([RouteConstants.EMPTY]);
    }
    return true;
  }
}
